import RequestApi from "../../utils/request";

export default {
	//测试
	TestData:(Data) => {
		// console.log(Data);
		///CMSAccount/Login
		var Url = '/api/Demo/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//修改登录密码
	UpdatePassword:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/UpdatePassword/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//修改操作密码
	UpdateKeyCode:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/UpdateKeyCode/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取管理员菜单
	GetMenuList:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/GetMenuList/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//编辑管理员菜单
	EditMenu:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/EditMenu/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//删除管理员菜单
	DeleteMenuList:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/DeleteMenuList/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取角色列表
	GetRoleList:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/GetRoleList/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//编辑角色
	EditRole:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/EditRole/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//删除角色
	DeleteRole:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/DeleteRole/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取角色绑定菜单列表
	GetRoleBindMenuList:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/GetRoleBindMenuList/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//编辑角色绑定裁断
	EditRoleBindMenu:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/EditRoleBindMenu/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取管理人员列表
	GetAdminList:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/GetAdminList/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//编辑管理人员
	EditAdmin:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/EditAdmin/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//删除管理人员
	DeleteAdmin:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/DeleteAdmin/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//设置管理人员角色
	SetRole:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/SetRole/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//重置登录密码及操作密码
	ResetPassword:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/ResetPassword/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//账号解锁
	IdUnlock:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/IdUnlock/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//IP黑名单
	GetIpBlackList:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/GetIpBlackList/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//编辑IP黑名单
	EditIpBlack:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/EditIpBlack/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//删除IP黑名单
	DeleteIpBlack:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/DeleteIpBlack/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取日志列表
	GetLogList:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Admin/GetLogList/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
}